import clsx from 'clsx';
import { PropsWithChildren } from 'react';
import { FormHelperTextProps } from './types';
import styles from './FormHelperText.module.css';

const FormHelperText = ({
  className,
  error,
  Component = 'span',
  children,
  ...rest
}: PropsWithChildren<FormHelperTextProps>) => (
  <div className={clsx(styles.helperText, 'helperText', className)} {...rest}>
    {children}
  </div>
);

export default FormHelperText;
